'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.WS = exports.WS_STATUS = void 0;
var pubsub_1 = require("../events/pubsub");
var session_1 = require("../session/session");
var events_1 = require("../events");
var id_1 = require("../util/id");
var WS_STATUS;
(function (WS_STATUS) {
    WS_STATUS[WS_STATUS["CONNECTING"] = 0] = "CONNECTING";
    WS_STATUS[WS_STATUS["CONNECTED"] = 1] = "CONNECTED";
    WS_STATUS[WS_STATUS["DISCONNECTING"] = 2] = "DISCONNECTING";
    WS_STATUS[WS_STATUS["DISCONNECTED"] = 3] = "DISCONNECTED";
})(WS_STATUS = exports.WS_STATUS || (exports.WS_STATUS = {}));
var WS = /** @class */ (function () {
    function WS(url, key, isDesktopDevice, driver) {
        this.url = url;
        this.key = key;
        this.isDesktopDevice = isDesktopDevice;
        this.driver = driver;
        this.pendingRequests = new Map();
        this.sid = '';
    }
    WS.prototype.connect = function () {
        var _this = this;
        return new Promise(function (resolve, reject) {
            var open = false;
            var sid = session_1.session.getId();
            if (!sid || (sid && _this.sid === sid && _this.conn)) {
                resolve();
                return;
            }
            _this.sid = sid;
            _this.conn = _this.initConn();
            var intervalId;
            _this.conn.onopen = function () {
                open = true;
                pubsub_1.pubsub.publish(pubsub_1.Topic.WSOpen, null);
                intervalId = setInterval(function () { return _this.request('/system/ping'); }, 45000);
                // prevent timer from blocking node process
                if (intervalId.unref) {
                    intervalId.unref();
                }
                resolve();
            };
            _this.conn.onclose = function (ev) {
                clearInterval(intervalId);
                pubsub_1.pubsub.publish(pubsub_1.Topic.WSClose, ev);
            };
            _this.conn.onerror = function (ev) {
                clearInterval(intervalId);
                if (!open) {
                    return reject(ev);
                }
                pubsub_1.pubsub.publish(pubsub_1.Topic.WSError, ev);
            };
            _this.conn.onmessage = function (e) { return _this.onMessage(e); };
        });
    };
    WS.prototype.request = function (path, params) {
        var _this = this;
        if (!this.conn) {
            return Promise.reject();
        }
        var id = id_1.generateId();
        var promise = new Promise(function (resolve, reject) {
            _this.pendingRequests.set(id, { resolve: resolve, reject: reject });
        });
        var msg = JSON.stringify({
            id: id,
            path: path,
            payload: params,
        });
        this.conn.send(msg);
        return promise;
    };
    WS.prototype.onMessage = function (event) {
        var msg = JSON.parse(event.data);
        var pending = this.pendingRequests.get(msg.id);
        if (pending) {
            msg.error
                ? pending.reject(msg.error)
                : pending.resolve(msg.payload);
            this.pendingRequests.delete(msg.id);
            return;
        }
        if (msg.topic) {
            events_1.events.distribute(msg.topic, msg.payload);
            return;
        }
    };
    WS.prototype.initConn = function () {
        if (this.conn) {
            // Close any previously opened connections.
            this.conn.onopen = null;
            this.conn.onclose = null;
            this.conn.onerror = null;
            this.conn.onmessage = null;
            this.conn.close();
        }
        var url = this.url + "/v2?key=" + this.key + "&isDesktopDevice=" + this.isDesktopDevice;
        var sid = session_1.session.getId();
        if (sid) {
            url += "&sid=" + sid;
        }
        if (this.driver) {
            return new this.driver(url);
        }
        return new WebSocket(url);
    };
    return WS;
}());
exports.WS = WS;
